export default "__VITE_ASSET__DajERSoU__"